import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const StatementOfCompliance = ({ statementOfCompliance }: SpecProps<"statement_of_compliance">) => {
  const { i18n } = useLingui();

  if (statementOfCompliance === undefined) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.statementOfCompliance",
    message: "Statement of compliance",
    comment: "Label for 'Statement of compliance'",
  });

  return <FieldValuePair field={field} value={statementOfCompliance} />;
};
